module.exports = __webpack_public_path__ + "img/head_img.b9224e53.jpg";